import React, { PureComponent } from 'react';
import axios from 'axios';
import InvitationSignupForm from './InvitationSignup';
import InvitationSignInForm from './InvitationSignin';
import { Modal, Button, notification } from 'antd';
import { FormattedMessage } from 'react-intl';
import { hp, cw } from "../../utils";

import company from '../../assets/img/company.svg';


class Invitation extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            token: window.location.pathname.split('/')[3],
            exists: false, loading: false, submitting: false,
            authenticated: props._auth.authenticated,
            account: {}, person: {}
        };
    }

    componentDidMount() {
        const self = this; //0855d92a-ef7d-4095-8335-9e5a03a07081 54b94331-486f-4fae-9c35-6564d644d1b6
        const { token } = this.state;
        this.setState({ loading: true });
        axios({
            method: 'GET',
            url: `${hp.getApiBaseUrl()}/invitations/${token}`,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        }).then((response) => {
            const res = response.data;
            const { _utils: { inv_email, inv_account, lang }, _auth: { user, authenticated } } = this.props;
            if (res.statusCode === 200 && res.data.status === 'PENDING') {
                this.props.setInvCookie('inv_email', res.data.email);
                this.props.setInvCookie('inv_accountId', res.data.inviterAccountId);
                axios({
                    method: 'GET',
                    url: `${hp.getApiBaseUrl()}/auth/validations/emails/${res.data.email}`,
                    json: false
                }).then((res) => {
                    this.setState({ loading: false });
                    if (res.data.statusCode === 200) {
                        this.setState({ exists: res.data.data.userExists });
                    }
                }).catch((err) => {
                    this.setState({ loading: false });
                });
            } else {
                Modal.info({
                    title: <FormattedMessage id="Invitation.Invalid.Title" defaultMessage="Invalid invitation link" />,
                    content: res.data.status === 'ACTIVE' ?
                        <FormattedMessage id="Invitation.Invalid.Description.Accepted" defaultMessage="This invitation has been accepted already" /> :
                        <FormattedMessage id="Invitation.Invalid.Description.Deleted" defaultMessage="This invitation has been deleted" />,
                    okText: 'Okay',
                    onOk() {
                        hp.deleteCookie('inv_email');
                        hp.deleteCookie('inv_person');
                        hp.deleteCookie('inv_account');
                        if (res.data.status === 'ACTIVE') {
                            if (authenticated) {
                                if (inv_email === user.email) {
                                    hp.setCookie('active_account', JSON.stringify(inv_account));
                                    window.location.assign(process.env.REACT_APP_SUCCESS_REDIRECT);
                                } else {
                                    window.location.assign(process.env.REACT_APP_SUCCESS_REDIRECT);
                                }
                            } else {
                                window.location.assign(`/${lang || 'en'}/signin${window.location.search}`);
                            }
                        } else {
                            window.location.assign(process.env.REACT_APP_SUCCESS_REDIRECT);
                        }
                    }
                });
            }
        }).catch((err) => {
            Modal.info({
                title: <FormattedMessage id="Invitation.Invalid.Title" defaultMessage="Invalid invitation link" />,
                content: <FormattedMessage id="Invitation.Invalid.Description.Database" defaultMessage="This invitation was not found in our database" />,
                okText: <FormattedMessage id="Button.SignIn" defaultMessage="Sign in" />,
                onOk() {
                    window.location.assign(`/${self.props._utils.lang || 'en'}/signin${window.location.search}`);
                }
            });
        });
    }

    confirmation = (action) => {
        const { _utils: { inv_email, inv_account } } = this.props;
        this.setState({ submitting: true });
        axios({
            method: 'POST',
            url: `${hp.getApiBaseUrl()}/invitations/${this.state.token}/user-confirmations`,
            json: true,
            data: { email: inv_email }
        }).then((res) => {
            if (res.data.statusCode === 200) {
                if (action === 'end') {
                    axios({
                        method: 'POST',
                        url: `${hp.getApiBaseUrl()}/auth/account-logins`,
                        headers: { 'x-access-token': hp.getCookie('user_token') },
                        data: {
                            accountId: res.data.data.account.id,
                            userId: res.data.data.user.id
                        }
                    }).then((response) => {
                        const res = response.data;
                        if (res.statusCode === 200) {
                            hp.setCookie('user_token', res.token);
                            hp.setCookie('project_id', inv_account.id);
                            hp.setCookie('active_account', JSON.stringify(inv_account));
                            window.location.assign(process.env.REACT_APP_SUCCESS_REDIRECT);
                        } else {
                            notification.error({ message: this.props.intl.formatMessage(cw['Error.Default']) });
                        }
                    }).catch(() => {
                        notification.error({ message: this.props.intl.formatMessage(cw['Error.Default']) });
                    });
                } else {
                    window.location.assign(process.env.REACT_APP_SUCCESS_REDIRECT);
                }
            } else {
                this.setState({ submitting: false });
                notification.error({ message: this.props.intl.formatMessage(cw['Success']), description: res.data.message });
            }
        }).catch((err) => {
            this.setState({ submitting: false });
            const res = JSON.parse((err.request || '').response);
            notification.error({ message: this.props.intl.formatMessage(cw['Failed']), description: res.message });
        });
    }

    keepSession = () => {
        const { _utils: { inv_email }, _auth: { user } } = this.props;
        if (inv_email !== user.email || this.state.exists === false) {
            hp.deleteCookie('inv_email');
            window.location.assign(process.env.REACT_APP_SUCCESS_REDIRECT);
        } else {
            this.confirmation('keep');
        }
    }

    endSession = () => {
        const { _utils: { inv_email }, _auth: { user } } = this.props;
        if (inv_email !== user.email || this.state.exists === false) {
            hp.deleteCookie('user');
            hp.deleteCookie('user_token');
            hp.deleteCookie('user_id');
            hp.deleteCookie('account');
            hp.deleteCookie('project_id');
            window.location.reload();
        } else {
            this.confirmation('end');
        }
    }


    render() {
        const { _utils: { inv_account } } = this.props;
        const { exists, authenticated, loading, submitting } = this.state;
        const activeAccount = hp.isJson(hp.getCookie('active_account')) ? JSON.parse(hp.getCookie('active_account')) : {}

        return (
            <React.Fragment>

                {loading === false && authenticated === false && exists === true && (
                    <InvitationSignInForm {...this.props} />
                )}

                {loading === false && authenticated === false && exists === false && (
                    <InvitationSignupForm {...this.props} />
                )}

                {loading === false && authenticated === true && (
                    <Modal className="invitation__modal" visible={true} title={null} closable={false} maskClosable={false} width={700} footer={[
                        <Button type="link" loading={submitting} onClick={() => this.keepSession()}>
                            <FormattedMessage id="Invitation.Button.Keep" defaultMessage="Continue Working" />
                        </Button>,
                        <Button type="primary" loading={submitting} onClick={() => this.endSession()}>
                            <FormattedMessage id="Invitation.Button.End" defaultMessage="Switch Organisation" />
                        </Button>
                    ]}>
                        <b style={{ padding: '2rem', display: 'block' }}>
                            <FormattedMessage
                                id="Invitation.Session.Text"
                                defaultMessage="Do you want to continue working in the current organisation?"
                            />
                        </b>

                        <div className="accounts">
                            <div className="account">
                                <div className="title"><FormattedMessage id="Invitation.ActiveAccount" defaultMessage="Current organisation" /></div>
                                <div>
                                    <div className="logo">
                                        <img src={activeAccount.logo || company} alt={activeAccount.name} />
                                    </div>
                                    <div className="text">
                                        <div><b>{activeAccount.name}</b></div>
                                        <div><small>{activeAccount.industry}</small></div>
                                    </div>
                                    <div style={{ clear: 'both' }} />
                                </div>
                            </div>
                            <div className="account invited">
                                <div className="title"><FormattedMessage id="Invitation.InvitedAccount" defaultMessage="Invited organisation" /></div>
                                <div>
                                    <div className="logo">
                                        <img src={inv_account.logo || company} alt={inv_account.name} />
                                    </div>
                                    <div className="text">
                                        <div><b>{inv_account.name}</b></div>
                                        <div><small>{inv_account.industry}</small></div>
                                    </div>
                                    <div style={{ clear: 'both' }} />
                                </div>
                            </div>
                            <div style={{ clear: 'both' }} />
                        </div>
                    </Modal>
                )}

            </React.Fragment>
        );
    }
}

export default Invitation;